import React, {useContext} from 'react';
import {createBuyOfferRequest, genericSellRequest} from 'util/api';
import ItemIcon from 'components/items/ItemIcon';
import 'styles/item/MyOffersPopup.css';
import {MarketContext} from 'util/market/MarketContext';
import {centsToString} from 'util/cashFormatter';
import {UserContext} from 'components/user/UserContext';

const MyTradeOffers = ({isBuy}) => {
    const {allItems} = useContext(MarketContext);
    const {user} = React.useContext(UserContext);

    const handleCancelBuy = async (itemType) => {
        try {
            if (isBuy) {
                await createBuyOfferRequest(itemType, 0, 0, user.balance);
            } else {
                await genericSellRequest(itemType, 0, 0);
            }
        } catch (error) {
            console.error('Error cancelling buy offer:', error);
        }
    };

    const filteredItems = allItems.filter(item => isBuy ? item.isUserBuying() : item.isUserSelling());

    return (
        <div className="my-trade-offers">
            <h1 style={{
                marginTop: '0px',
                marginBottom: '10px',
                color: '#4E6C55'
            }}>{isBuy ? 'My Buy Offers' : 'My Sell Offers'}</h1>
            <table>
                <thead>
                <tr>
                    <th>Since</th>
                    <th>Count</th>
                    <th>Item</th>
                    <th>Price</th>
                    <th>Cancel</th>
                </tr>
                </thead>
                <tbody>
                {filteredItems.map((item, index) => (
                    <tr key={index}>
                        <td>{new Date(isBuy ? item.getUserBuyingSince() : item.getUserSellingSince()).toLocaleString()}</td>
                        <td>{isBuy ? item.getUserBuyingQuantity() : item.getUserSellingQuantity()}x</td>
                        <td><ItemIcon lootItem={item.itemType}/></td>
                        <td>{centsToString(isBuy ? item.getUserBo() : item.getUserSo())}</td>
                        <td style={{color: 'red', cursor: 'pointer'}}
                            onClick={() => handleCancelBuy(item.itemType, index)}>&#x2716;</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default MyTradeOffers;